// extracted by LIB_CSS_EXTRACT_LOADER
import "./checkbox_module.css"
export default {"checkbox":"checkbox-Wu1gAd","indicator":"indicator-zquFRe"};